import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "flex h-9 w-full rounded-xl border-0 bg-background px-3 py-1 text-base transition-shadow file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground shadow-[inset_2px_2px_5px_hsl(var(--neo-dark)/0.3),inset_-2px_-2px_5px_hsl(var(--neo-light)/0.7)] focus-visible:outline-none focus-visible:shadow-[inset_2px_2px_5px_hsl(var(--neo-dark)/0.35),inset_-2px_-2px_5px_hsl(var(--neo-light)/0.75),0_0_0_2px_hsl(var(--ring)/0.4)] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
